import { Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-primeng-input-text',
  templateUrl: './primeng-input-text.component.html',
  styleUrls: ['./primeng-input-text.component.scss'],
  standalone: false,
})
export class PrimengInputTextComponent {
  value = model<string>('');
  placeholder = input<string>('');
  disabled = input<boolean>(false);
  readonly = input<boolean>(false);
  type = input<string>('text');
  maxlength = input<number | null>(null);
  styleClass = input<string>('');
  size = input<'small' | 'large' | undefined>(undefined);
  fluid = input<boolean>(false);
  id = input<string>('');
  label = input<string>('');
  icon = input<string>('');
  iconPosition = input<'left' | 'right'>('left');

  onInput = output<Event>();
  onBlur = output<Event>();
  onFocus = output<Event>();

  handleInput(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target) {
      this.value.set(target.value);
    }
    this.onInput.emit(event);
  }

  handleBlur(event: Event) {
    this.onBlur.emit(event);
  }

  handleFocus(event: Event) {
    this.onFocus.emit(event);
  }
}
